export default {"src":"/_next/static/media/consul_on-light.0d4b41ad.svg","height":72,"width":202,"blurWidth":0,"blurHeight":0};